import http from './httpService';

const apiEndPoint = '/btrades';

function bitcoinsTradeUrl(id) {
  return `${apiEndPoint}/${id}`;
}

function tradeCompletionCheckUrl(id) {
  return `/btrades/complete-status/${id}`;
}

function tradeApprovalCheckUrl(id) {
  return `/btrades/approve-status/${id}`;
}

export function getBitcoinsTrades() {
  return http.get(apiEndPoint);
}

export function getBitcoinsTrade(bitcoinsTradeId) {
  return http.get(bitcoinsTradeUrl(bitcoinsTradeId));
}

export function saveBitcoinsTrade(bitcoinsTrade) {
  if (bitcoinsTrade._id) {
    const body = { ...bitcoinsTrade };
    delete body._id;
    return http.put(bitcoinsTradeUrl(bitcoinsTrade._id), body);
  }

  return http.post(apiEndPoint, bitcoinsTrade);
}

export function deleteBitcoinsTrade(bitcoinsTradeId) {
  return http.delete(bitcoinsTradeUrl(bitcoinsTradeId));
}

export function tradeCompletionStatus(bitcoinsTrade) {
  if (bitcoinsTrade._id) {
    const body = { ...bitcoinsTrade };
    delete body._id;
    return http.put(tradeCompletionCheckUrl(bitcoinsTrade._id), body);
  }
}

export function tradeApprovalStatus(bitcoinsTrade) {
  if (bitcoinsTrade._id) {
    const body = { ...bitcoinsTrade };
    delete body._id;
    return http.put(tradeApprovalCheckUrl(bitcoinsTrade._id), body);
  }
}
